/* Default Colors */
/* CI/CD Colors */
/* 2021 TS Colors */
/* Scrollbars */
*:focus {
	outline: var(--oebb-outline, 2px dotted var(--oebb-accent-color, #e2002a));
	outline-offset: var(--oebb-outline-offset, 2px);
}

*:focus:not(:focus-visible) {
	outline: none;
}

*:focus-visible {
	outline: var(--oebb-outline, 2px dotted var(--oebb-accent-color, #e2002a));
	outline-offset: var(--oebb-outline-offset, 2px);
}

.hidden {
	display: none;
}

.invisible {
	visibility: hidden;
}

.offscreen {
	position: absolute;
	left: -1000em;
}

.screen-reader-text {
	position: absolute;

	width: 1px;
	height: 1px;
	margin: -1px;
	padding: 0;
	overflow: hidden;

	border: 0;
	clip-path: inset(50%);

	white-space: nowrap;
}

.screen-reader-text--focusable:active,
.screen-reader-text--focusable:focus {
	position: relative;

	width: auto;
	height: auto;
	margin: 0;
	overflow: visible;

	clip-path: none;

	white-space: inherit;
}

/** @deprecated */
/** ".is-tabbing" should be added via JavaScript and shows the outline. Used with class to not show outline on clicking elements. */
.is-tabbing button::-moz-focus-inner,
:host(.is-tabbing) button::-moz-focus-inner {
	border: 0;
}

.is-tabbing--focus,
.is-tabbing a:focus,
.is-tabbing button:focus,
.is-tabbing div:focus,
.is-tabbing input:focus,
.is-tabbing input:focus ~ span[role="presentation"],
:host(.is-tabbing) a:focus,
:host(.is-tabbing) button:focus,
:host(.is-tabbing) div:focus,
:host(.is-tabbing) input:focus,
:host(.is-tabbing) input:focus ~ span[role="presentation"] {
	outline: 2px dotted #e2002a;
	outline-offset: 2px;
	z-index: 10;
}

:host {
  --expandable-internal-separator: var(--expandable-separator, 1px solid #e4e4e4);
  --expandable-internal-header-gap: var(--expandable-header-gap, 5px);
  --expandable-internal-header-color: var(--expandable-header-color, inherit);
  --expandable-internal-header-color-hover: var(--expandable-header-color-hover, inherit);
  --expandable-internal-header-background: var(--expandable-header-background, #fff);
  --expandable-internal-header-background-hover: var(--expandable-header-background-hover, transparent);
  --expandable-internal-header-icon-color: var(--expandable-header-icon-color, currentColor);
  --expandable-internal-header-icon-color-hover: var(--expandable-header-icon-color-hover, currentColor);
  --expandable-internal-body-background: var(--expandable-body-background, #fff);
  --expandable-internal-padding: var(--expandable-padding, 0.75rem);
  --expandable-internal-padding-calc: calc(var(--expandable-internal-padding) + var(--expandable-internal-header-gap) + 15px);
  --expandable-internal-animation-height-duration: 0.3s;
  --expandable-internal-animation-fade-in-duration: 0.5s;
  --expandable-internal-animation-fade-out-duration: 0.3s;
}

.expandable-item {
  border-bottom: var(--expandable-internal-separator);
  /* Visibility animation prevents items inside to get focus if the expandable item is not open. */
}
.expandable-item-header {
  display: flex;
  gap: var(--expandable-internal-header-gap);
  box-sizing: border-box;
  width: 100%;
  padding: var(--expandable-internal-padding) var(--expandable-internal-padding-calc) var(--expandable-internal-padding) var(--expandable-internal-padding);
  color: var(--expandable-internal-header-color);
  background: var(--expandable-internal-header-background);
  border: none;
  cursor: pointer;
  font-family: inherit;
  font-size: inherit;
  font-weight: 700;
  text-decoration: none;
  text-align: inherit;
  align-items: center;
}
.expandable-item-header:hover {
  color: var(--expandable-internal-header-color-hover);
  background: var(----expandable-internal-header-background-hover);
}
.expandable-item-header:hover oebbx-icon svg {
  fill: var(--expandable-internal-header-icon-color-hover);
}
.expandable-item-header oebbx-icon svg {
  fill: var(--expandable-internal-header-icon-color);
  transform: translateY(2px) rotate(90deg);
  transition: transform 0.3s ease-in-out;
}
.expandable-item-open .expandable-item-header oebbx-icon svg {
  transform: translateY(2px) rotate(-90deg);
}
.expandable-item-body {
  overflow: hidden;
  background: var(--expandable-internal-body-background);
  transition: height var(--expandable-internal-animation-height-duration) ease-in-out;
  height: 0;
}
.expandable-item-open .expandable-item-body {
  height: auto;
}
.expandable-item-content {
  padding: var(--expandable-internal-padding) var(--expandable-internal-padding-calc);
  opacity: 0;
  visibility: hidden;
  transition: opacity var(--expandable-internal-animation-fade-out-duration) ease-in-out, visibility 0.01s ease var(--expandable-internal-animation-height-duration);
}
.expandable-item-open .expandable-item-content {
  opacity: 1;
  visibility: visible;
  transition: opacity var(--expandable-internal-animation-fade-in-duration) ease-in-out, visibility 0.01s ease 0s;
}